import api from './api';

export const getCartApi = async () => {
    const res = await api.get("/api/v1/cart");
    return res.data;
};

export const addItemToCartApi = async (data) => {
    const res = await api.post("/api/v1/cart/add", data);
    return res.data;
};

export const updateItemQuantityApi = async (data) => {
    const res = await api.put("/api/v1/cart/update", data);
    return res.data;
};

export const removeItemFromCartApi = async (data) => {
    // Axios delete with body requires 'data' property
    const res = await api.delete("/api/v1/cart/remove", { data });
    return res.data;
};

export const clearCartApi = async () => {
    const res = await api.delete("/api/v1/cart/clear");
    return res.data;
};
